import axios from "axios";

export const http = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Network error callback - will be set by the React app
let networkErrorCallback = null;

export const setNetworkErrorCallback = (callback) => {
  networkErrorCallback = callback;
};

// Auth error callback - will be set by the React app for handling 401/403 responses
// eslint-disable-next-line no-unused-vars
let authErrorCallback = null;

export const setAuthErrorCallback = (callback) => {
  authErrorCallback = callback;
};

http.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle network errors (no response from server)
    if (!error.response && networkErrorCallback) {
      // Check if it's a network error (not a cancelled request)
      if (!axios.isCancel(error)) {
        networkErrorCallback(
          error.message || "Network error. Please check your connection.",
        );
        // Return a never-resolving promise to prevent components from catching the error
        // This completely stops the error propagation and prevents toastrs from showing
        return new Promise(() => {});
      }
    }

    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken");
      // Optional: redirect to login
      // window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

// Generic function to perform CRUD operations
const performRequest = async (method, url, data, config = {}) => {
  try {
    const response = await method(url, data, config);
    return response;
  } catch (error) {
    // Re-throw the error so it can be caught by the caller
    throw error;
  }
};

export const get = async (url, config = {}) => {
  return performRequest(http.get, url, config);
};

export const post = async (url, data, config = {}) => {
  return performRequest(http.post, url, data, config);
};

export const postFormData = async (url, formData, config = {}) => {
  const formDataConfig = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": "multipart/form-data",
    },
  };
  return performRequest(http.post, url, formData, formDataConfig);
};

export const put = async (url, data, config = {}) => {
  return performRequest(http.put, url, data, config);
};
export const patch = async (url, data, config = {}) => {
  return performRequest(http.patch, url, data, config);
};

export const del = async (url, data = {}, config = {}) => {
  return performRequest(http.delete, url, { data, ...config });
};

export const deleteRequest = del;
